import axiosInstance from "../services/axios";

export const subscribeToNewsletter = async (email: string) => {
  const res = await axiosInstance.post("http://localhost:3001/subscribers", {
    email,
    entityName: "AREL",
  });
  return res.data;
};
